import type { CampaignAllocation } from "features/MarketingMaterials/api/campaignApi.ts";
import * as Styles from "../CampaignShippingPage.styles.ts";

interface CampaignKitCardProps {
	item: CampaignAllocation;
}

export const CampaignKitCard = ({ item }: CampaignKitCardProps) => (
	<Styles.KitCard>
		<div>
			<p className="campaign-kit-title">{item.itemKitName || item.itemLaunchKitType || "Launch Kit"}</p>
			<p className="campaign-kit-sku">{item.itemLaunchKitType || item.itemKitName}</p>
		</div>
		<div className="campaign-kit-image">
			{item.imageUrl ? (
				<img
					src={item.imageUrl}
					alt={item.itemKitName || item.itemLaunchKitType || "Launch kit"}
				/>
			) : null}
		</div>
		<div className="campaign-kit-meta">
			<p className="campaign-kit-label">Qty</p>
			<p>{item.quantity}</p>
		</div>
		<div className="campaign-kit-meta">
			<p className="campaign-kit-label">Product Line</p>
			<p>{item.productLine || "—"}</p>
		</div>
		<div className="campaign-kit-meta">
			<p className="campaign-kit-label">Launch Date</p>
			<p>
				{new Date(item.startDate).toLocaleDateString()} – {new Date(item.expirationDate).toLocaleDateString()}
			</p>
		</div>
	</Styles.KitCard>
);
